import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import PageHero from "@/components/PageHero";
import { Reveal, Label } from "@/components/Reveal";
import { Icon } from "@/components/icons";
import CTASection from "@/components/CTASection";
import { IMAGES, SERVICES } from "@/lib/data";

const ServiceCards = () => (
  <section className="bg-white" data-testid="services-list">
    <div className="max-w-[1400px] mx-auto px-6 md:px-12 py-24">
      <Reveal className="text-center max-w-3xl mx-auto mb-16">
        <h2 className="font-heading text-4xl md:text-5xl uppercase font-bold text-navy tracking-tight">Our Services</h2>
        <p className="mt-6 text-lg text-navy/70 leading-relaxed">
          We partner with architects, owners, developers, and contractors to deliver practical, evidence-based solutions for every stage of a building's lifecycle.
        </p>
      </Reveal>
      <div className="grid md:grid-cols-2 gap-6">
        {SERVICES.map((s, i) => (
          <Reveal key={s.title} delay={(i % 2) * 0.1}>
            <div className="group h-full border border-border p-8 md:p-10 hover:-translate-y-1 hover:shadow-[0_20px_50px_-20px_rgba(10,25,47,0.25)] transition-all duration-300" data-testid={`service-${i}`}>
              <div className="flex items-start gap-5">
                <div className="w-14 h-14 bg-brand-light flex items-center justify-center shrink-0">
                  <Icon name={s.icon} className="w-7 h-7 text-brand" strokeWidth={1.5} />
                </div>
                <div>
                  <h3 className="font-heading uppercase text-navy font-semibold text-xl leading-tight">{s.title}</h3>
                  <p className="text-sm text-navy/60 leading-relaxed mt-3">{s.desc}</p>
                </div>
              </div>
              <div className="border-t border-border my-7" />
              <ul className="space-y-2.5">
                {s.points.map((pt) => (
                  <li key={pt} className="flex items-center gap-3 text-sm text-navy/80">
                    <span className="w-1.5 h-1.5 bg-brand rounded-full shrink-0" />
                    {pt}
                  </li>
                ))}
              </ul>
              <Link to="/contact" data-testid={`service-cta-${i}`}
                    className="group/link inline-flex items-center gap-2 mt-8 text-xs tracking-[0.18em] uppercase font-bold text-brand hover:text-navy transition-colors">
                Learn More <ArrowRight className="w-4 h-4 group-hover/link:translate-x-1 transition-transform" />
              </Link>
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);

export default function Services() {
  return (
    <>
      <PageHero
        label="Services"
        titleLines={["Science. Expertise.", "Better Buildings."]}
        description="We provide building science consulting services that help create high-performance, durable, and sustainable buildings."
        image={IMAGES.servicesHero}
        imageAlt="Building plans"
      />
      <ServiceCards />
      <CTASection />
    </>
  );
}
